import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="py-24 bg-brand-teal text-brand-cream relative overflow-hidden" data-id="element-100">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-101"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl" data-id="element-102"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-103">
        <FadeIn data-id="element-104">
          <div className="flex justify-center mb-8" data-id="element-105">
            <ShieldIcon className="w-12 h-12 text-brand-gold" strokeWidth={1.5} data-id="element-106" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 text-white" data-id="element-107">
            Presentamos el{' '}
            <span className="text-brand-gold" data-id="element-108">Método Zero-Friction</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-109">
          <div className="space-y-6 text-lg md:text-xl text-brand-cream/90 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-110">
            <p data-id="element-111">
              A diferencia de los planes de ahorro tradicionales, este sistema
              no depende de tu memoria ni de tu autodisciplina.
            </p>
            <p data-id="element-112">
              Es una <strong data-id="element-113">"prótesis cognitiva" financiera</strong> que asume
              que te vas a distraer, que vas a olvidar las fechas y que vas a
              querer comprar cosas a medianoche.
            </p>
            <p className="font-serif italic text-brand-gold text-2xl mt-8" data-id="element-114">
              "El sistema construye muros de contención automáticos alrededor de
              tu cuenta bancaria para que tu dinero se quede donde pertenece:
              con Dios y contigo."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}